<template>
    <v-menu
            style="width: 80%;"
            lazy
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            :nudge-bottom="-24"
            v-model="menu"
    >
        <v-text-field
                slot="activator"
                :label="label"
                :clearable="clearable"
                v-model="pin"
                :rules="rules"
                append-icon="location"
                readonly
        ></v-text-field>
        <Map only-markers height="90vh" :appendMarkers="[marker]"/>
    </v-menu>
</template>

<script>
    import Map from "@/views/monitoring/Map";
    import Mapbox from "mapbox-gl";
    import ChooseLocationMulti from "@/components/wasilni/input/ChooseLocationMulti";


    export default {
        components: {ChooseLocationMulti, Map},
        name: "choose-pin",
        props: {
            'label': {}, 'value': {}, 'rules': {}, clearable: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                pin: this.value,
                menu: false,
                location: null
            }
        },
        watch: {
            pin(val) {
                // update value of marker as well
                this.$emit('input', val);
            },
            value(val) {
                this.pin = val;
            },
            menu(val) {
                if (!val)
                    this.pin = this.marker._lngLat.toArray();
            },
            location(val) {
                if (!!val) {
                    console.log(val);
                }
            }
        },
        computed: {
            marker() {
                const marker = new Mapbox.Marker({
                    color: "#00ff0f",
                    symbol: 'S',
                    draggable: true
                });
                marker.setLngLat(this.api.mapBox.center);
                return marker;
            }
        }
    }
</script>

<style scoped>

</style>